export function getQuestionnaireLanguageFromStorage() {
    return localStorage.survey_language;
}